import React from "react";

import {
    FeaturedRichTextBlock as FeaturedRichTextBlockProps,
    FeaturedRichText as FeaturedRichTextProps,
} from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { H, HLevel } from "../Headings";
import { RichText } from "../RichText";
import { ThemedModule } from "../ThemedModule";

import fonts from "../../styles/typography.module.scss";
import styles from "./FeaturedRichText.module.scss";

export const FeaturedRichtext = (props: { value: FeaturedRichTextProps }) => {
    if (!props.value.stream) return;
    return (
        <HLevel>
            <div
                className={
                    props.value.alignment === "left"
                        ? styles.alignLeft
                        : styles.alignCenter
                }
            >
                {props.value.stream.map((block) => {
                    if (block.type === "heading") {
                        return (
                            <RichText
                                key={block.id}
                                value={block.value.text!}
                                blockOverrides={{
                                    unstyled: {
                                        element: block.value.is_semantic
                                            ? H
                                            : "p",
                                        props: {
                                            className: concatClassNames([
                                                styles.heading,
                                                block.value.style
                                                    ? fonts[block.value.style]
                                                    : undefined,
                                            ]),
                                        },
                                    },
                                }}
                            />
                        );
                    } else {
                        return (
                            <HLevel key={block.id}>
                                <RichText
                                    className={styles.body}
                                    value={block.value}
                                    blockOverrides={{
                                        unstyled: {
                                            element: "p",
                                            props: {
                                                className: styles.bodyText,
                                            },
                                        },
                                    }}
                                />
                            </HLevel>
                        );
                    }
                })}
            </div>
        </HLevel>
    );
};

export const FeaturedRichtextBlock = (props: {
    value: FeaturedRichTextBlockProps;
}) => {
    if (!props.value.stream) return;
    return (
        <ThemedModule theme={props.value.module_theme}>
            <FeaturedRichtext value={props.value} />
        </ThemedModule>
    );
};
